import { getCurrentInstance } from 'vue';
import type { ModalService } from './modal-service';

export function useModal(): ModalService {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error('useModal() can be only used in setup()');
  }
  const modalService = instance.appContext.config.globalProperties.$imodal as
    | ModalService
    | undefined;
  if (!modalService) {
    throw new Error(
      'Modal plugin is not installed. Please install the modal plugin before using useModal().',
    );
  }
  return modalService;
}
